// Import and register all your controllers from the importmap under controllers/*

import { application } from "./application"

// Import and register all controllers
import AutoRefreshController from "./auto_refresh_controller"
import BankAccountsController from "./bank_accounts_controller"
import ConditionalFieldController from "./conditional_field_controller"
import ConfirmDeleteController from "./confirm_delete_controller"
import InlineEditController from "./inline_edit_controller"
import PriceCalculatorController from "./price_calculator_controller"
import VatToggleController from "./vat_toggle_controller"

application.register("auto-refresh", AutoRefreshController)
application.register("bank-accounts", BankAccountsController)
application.register("conditional-field", ConditionalFieldController)
application.register("confirm-delete", ConfirmDeleteController)
application.register("inline-edit", InlineEditController)
application.register("price-calculator", PriceCalculatorController)
application.register("vat-toggle", VatToggleController)
